import { render, staticRenderFns } from "./WebsiteMobileNavigationLink.vue?vue&type=template&id=4df83f30"
import script from "./WebsiteMobileNavigationLink.vue?vue&type=script&lang=ts"
export * from "./WebsiteMobileNavigationLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports